import { BupSpinner, ResourceBupCard } from '@BUP/components';
import React from 'react';
import { Row } from 'antd';
import { useAuth, useTopics } from '@BUP/hooks';
import { ECE, ASSISTANT, TEACHER } from '@BUP/constants';
import { useTranslation } from 'react-i18next';
import styles from './resource-list.module.css';

const ResourceBupList = ({
  resource,
  resources,
  loadingResources,
  errorResources,
}) => {
  const { user } = useAuth();
  const roleType = user?.roles.type;
  const resourceId = resource?.id;
  const levelId = user?.courses?.levelId;

  const { data: topics, isLoading: isLoadingTopics } = useTopics(
    resourceId,
    levelId
  );
  const [t] = useTranslation();

  return (
    <>
      {loadingResources || isLoadingTopics ? (
        <div className={styles.loading_wrapper}>
          <BupSpinner size="medium" />
        </div>
      ) : errorResources ? (
        <div className={styles.error_wrapper}>
          <h3 className={styles.error_text}>{t('pages.home.errorMessage')}</h3>
        </div>
      ) : resources && resources.length ? (
        <Row className={styles.container} type="flex" align="middle">
          {roleType === ECE || roleType === ASSISTANT || roleType === TEACHER
            ? resources.map((resource) => (
                <ResourceBupCard resource={resource} />
              ))
            : topics.map((topic) => (
                <ResourceBupCard
                  topic={topic}
                  resourceId={resourceId}
                  key={`${topic?.id}`}
                />
              ))}
        </Row>
      ) : (
        <div className={styles.no_message_wrapper}>
          <h3 className={styles.no_message_text}>
            {t('pages.home.noResources')}
          </h3>
        </div>
      )}
    </>
  );
};

export default ResourceBupList;
